import { ipsos, supuesto } from ".";

// Lámina 75 (base 400).
const P_CONSUME = "¿Consume comida rápida (fast food)?";
const P_FRECUENCIA = "¿Con qué frecuencia consume fast food?";
const P_MARCA = "¿Cuál es su marca de fast food preferida?";

export const IPSOS_FASTFOOD = {
  consumeFastFood: ipsos(0.652, { lamina: 75, pregunta: P_CONSUME, base: 400 }),
  noConsume: ipsos(0.348, { lamina: 75, pregunta: P_CONSUME, base: 400 }),

  // factor = consumos/mes (supuesto comercial derivado de la etiqueta de frecuencia Ipsos)
  frecuenciaConsumo: {
    unaVezMes: {
      pct: ipsos(0.31, { lamina: 75, pregunta: P_FRECUENCIA, base: 400 }),
      factor: supuesto(1, { nota: "consumos/mes" }),
    },
    unaVezSemana: {
      pct: ipsos(0.492, { lamina: 75, pregunta: P_FRECUENCIA, base: 400 }),
      factor: supuesto(4, { nota: "consumos/mes" }),
    },
    dosOMasVecesSemana: {
      pct: ipsos(0.19, { lamina: 75, pregunta: P_FRECUENCIA, base: 400 }),
      factor: supuesto(10, { nota: "consumos/mes" }),
    },
    otro: {
      pct: ipsos(0.01, { lamina: 75, pregunta: P_FRECUENCIA, base: 400 }),
      factor: supuesto(0, { nota: "consumos/mes" }),
    },
  },

  marcas: {
    "McDonald's": ipsos(0.467, { lamina: 75, pregunta: P_MARCA, base: 400 }),
    "Burger King": ipsos(0.14, { lamina: 75, pregunta: P_MARCA, base: 400 }),
    KFC: ipsos(0.094, { lamina: 75, pregunta: P_MARCA, base: 400 }),
    "Carl's Jr": ipsos(0.09, { lamina: 75, pregunta: P_MARCA, base: 400 }),
    Domino: ipsos(0.058, { lamina: 75, pregunta: P_MARCA, base: 400 }),
    Subway: ipsos(0.056, { lamina: 75, pregunta: P_MARCA, base: 400 }),
    "Pizza Hut": ipsos(0.028, { lamina: 75, pregunta: P_MARCA, base: 400 }),
    "Papa Johns": ipsos(0.009, { lamina: 75, pregunta: P_MARCA, base: 400 }),
    Otros: ipsos(0.057, {
      lamina: 75,
      pregunta: P_MARCA,
      base: 400,
      nota: "Taragona 2,2% + New Shuchi 1,7% + Juan Maestro 1,1% + Mamut 0,7%",
    }),
  },
};

// Supuestos comerciales — ticket promedio (CLP)
export const TICKETS_PROMEDIO_FASTFOOD = [
  supuesto(6000, { nota: "ticket promedio" }),
  supuesto(8000, { nota: "ticket promedio" }),
  supuesto(10000, { nota: "ticket promedio" }),
  supuesto(12000, { nota: "ticket promedio" }),
];

export const ESCENARIOS_CRECIMIENTO_FASTFOOD = [
  supuesto(5, { nota: "% crecimiento de share simulado" }),
  supuesto(10, { nota: "% crecimiento de share simulado" }),
  supuesto(20, { nota: "% crecimiento de share simulado" }),
];
